import { Expose } from "class-transformer";
import { InformalOfferBase } from "domain/model/base";

export default class InformalOffer extends InformalOfferBase {
  @Expose({name: "company_name"})
  companyName?: string;
};
